import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { LoginTypePayload, LoginTypeResponse, SsoTokenPayload } from '@Types'
import { ApexAuth } from 'apex-ui-services'
import { RootState } from '../../store'
import { LEGIT_SERVICE_CONFIG } from '../../constants/okta'
import { ALL_REQUESTED_PERMISSIONS } from '../../constants'
import { legit } from 'apex-legit-service'
import { useOktaAuth } from '@okta/okta-react'
import { AccessToken, IDToken } from '@okta/okta-auth-js'
import { LoginPage } from './Login'

export interface Props {
  idpCheck: (params: LoginTypePayload) => void
  loginTypeResponse?: LoginTypeResponse | null
  ssoLogin: (params: SsoTokenPayload) => void
  isLegacyLoginLoading: boolean
  ssoLoginIsLoading: boolean
  isLoginTypeLoading: boolean
  adoptLegitSession: (config: Record<string, any>, requestedPermissions: string[]) => void
  failedLegitAuth: boolean
  isSessionLoading: boolean
}

export const ApexLoginComponent = ({ adoptLegitSession, ssoLogin, isSessionLoading, ssoLoginIsLoading }: Props) => {
  // eslint-disable-next-line
  const { authState, oktaAuth } = useOktaAuth()
  useEffect(() => {
    if (authState?.isAuthenticated) {
      const idToken: IDToken = authState?.idToken
      const accessToken: AccessToken = authState?.accessToken
      ssoLogin({
        idToken: idToken?.idToken,
        accessToken: accessToken?.accessToken
      })
    }
    // eslint-disable-next-line
  }, [authState])

  useEffect(() => {
    if (!ssoLoginIsLoading) {
      adoptLegitSession(LEGIT_SERVICE_CONFIG, ALL_REQUESTED_PERMISSIONS)
    }
    // eslint-disable-next-line
  }, [ssoLoginIsLoading])

  return <LoginPage isLoadingSession={isSessionLoading} />
}

const mapStateToProps = (state: RootState) => {
  const legitAuthState = (state as any)?.APEX_LEGIT_AUTHORIZATION?.status
  return {
    isLegacyLoginLoading: legit.selectors.isSessionLoading(state),
    loginTypeResponse: ApexAuth.loginType.selectors.loginType(state),
    isLoginTypeLoading: ApexAuth.loginType.selectors.isLoginTypeLoading(state),
    ssoLoginIsLoading: ApexAuth.loginSso.selectors.isSsoLoginLoading(state),
    failedLegitAuth: legitAuthState === 'APEX_LEGIT_AUTHORIZATION/FAILURE'
  }
}

const mapDispatchToProps = {
  adoptLegitSession: legit.adoptExistingSession,
  idpCheck: ApexAuth.loginType.actions.getLoginType.request,
  ssoLogin: ApexAuth.loginSso.actions.createSsoLogin.request
}

export const ApexLogin = connect(mapStateToProps, mapDispatchToProps)(ApexLoginComponent)
